import styled, { keyframes } from 'styled-components';

// 페이지 로딩 스켈레톤 UI
const PageLoadingSkeleton = () => {
	return (
		<Container>
			<Header>
				<HeaderContents>
					<HeaderSkeleton />
				</HeaderContents>
			</Header>
			<Content>
				<TitleSkeleton />
				<SubTitleSkeleton />
				<Divider />
				<ContentBlock>
					<LineSkeleton width="60%" />
					<LineSkeleton width="80%" />
					<LineSkeleton width="40%" />
				</ContentBlock>
				<ContentBlock>
					<LineSkeleton width="70%" />
					<LineSkeleton width="90%" />
					<LineSkeleton width="50%" />
				</ContentBlock>
			</Content>
		</Container>
	);
};

export default PageLoadingSkeleton;

const shimmer = keyframes`
  0% {
    background-position: -1000px 0;
  }
  100% {
    background-position: 1000px 0;
  }
`;

const Container = styled.div`
  width: 100vw;
  min-height: 100vh;
`;

const Header = styled.div`
  height: 80px;
  background-color: #fff;
  border-bottom: 1px solid #F3F3F3;
`;
const HeaderContents = styled.div`
  width: 1280px;
  height: 100%;
  display: flex;
  align-items: center;
  margin: 0 auto;
`;

const HeaderSkeleton = styled.div`
  width: 152px;
  height: 30px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 1000px 100%;
  animation: ${shimmer} 2s infinite;
  border-radius: 4px;
`;

const Content = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 32px 0;
`;

const TitleSkeleton = styled.div`
  width: 200px;
  height: 32px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 1000px 100%;
  animation: ${shimmer} 2s infinite;
  border-radius: 4px;
  margin-bottom: 12px;
`;

const SubTitleSkeleton = styled.div`
  width: 300px;
  height: 20px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 1000px 100%;
  animation: ${shimmer} 2s infinite;
  border-radius: 4px;
  margin-bottom: 24px;
`;

const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: #F3F3F3;
  margin-bottom: 32px;
`;

const ContentBlock = styled.div`
  margin-bottom: 32px;
`;

const LineSkeleton = styled.div<{ width: string }>`
  width: ${(props) => props.width};
  height: 16px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 1000px 100%;
  animation: ${shimmer} 2s infinite;
  border-radius: 4px;
  margin-bottom: 12px;
`;
